import styled from 'styled-components';
import { theme } from '../../styles/theme';
const { rbmWhite } = theme.colors;

export const Container = styled.div`
  margin-left: 4.667vw;
  margin-right: 1.667vw;
  margin-bottom: 0.5vw;
`;

export const Header = styled.div`
  margin: ${(props) => props.margin || '1.667vw 0'};
  display: flex;
  align-items: flex-end;
  h4 {
    font-weight: 600;
    font-size: 1.667vw;
    font-family: 'Poppins';
  }
`;
